
import React from 'react';
import TipFeedback from './TipFeedback';

interface ActionStepProps {
  title: string;
  description: string;
  tipRating: 'up' | 'down' | null;
  setTipRating: React.Dispatch<React.SetStateAction<'up' | 'down' | null>>;
  lessonDay: number;
}

const ActionStep: React.FC<ActionStepProps> = ({ 
  title, 
  description, 
  tipRating, 
  setTipRating, 
  lessonDay 
}) => {
  return (
    <div className="bg-hormony-light-coral/20 p-4 rounded-xl space-y-2">
      <h3 className="font-semibold text-hormony-charcoal">
        Action Step: {title}
      </h3>
      <p className="text-hormony-charcoal/80">
        {description}
      </p>
      
      <TipFeedback 
        tipRating={tipRating} 
        setTipRating={setTipRating} 
        lessonDay={lessonDay} 
      />
    </div>
  );
};

export default ActionStep;
